import React from 'react';
import { func, object, number, string } from 'prop-types';
import { Download } from "react-feather";
import IntersectionVisible from 'react-intersection-visible';

import { DEFAULT_ATTACHMENT_URL } from '../../constants/AppConstants';
import LoadingState from '../LoadingState';

import s from './Attachment.css';


/**
 * At the time of this writing, this component is using an experimental API: IntersectionObserver.
 * The package gives us a simple, straight-forward use-case for populating an Attachment's
 * url to download as it comes into the viewport. Without this, we're custom-rolling
 * our own messy code to calculate scroll events.
 * https://github.com/AvraamMavridis/react-intersection-visible
 *
 * @prop id - the id passed from MessagesList -> AttachmentsList
 */
const Attachment = ({id, url, error, filename, mimeType, getAttachment}) => {
    /**
     * IntersectionVisible fires this when the Attachment is in view.
     * @param entries: a single array object returned by the IntersectionObserver api.
     */
    const getUrl = () => {
        if (url === DEFAULT_ATTACHMENT_URL) {
            const request = { id, mimeType };
            getAttachment(request);
        }
    };

    const downloaded = !!url && url !== DEFAULT_ATTACHMENT_URL;

    return (
        <IntersectionVisible
            className={s.component}
            options={{threshold: 0.5}}
            onShow={getUrl}
        >
            <div
                className={s.speechBubble}
                key={id}
            >
                {error ?
                <p className={s.body}>
                    Unable to download attachment
                </p>
                :
                <a
                    download={filename}
                    className={s.body}
                    id={`attachment-${id}`}
                    href={url}
                    title={`Download ${filename}`}
                >
                    {!downloaded ?
                        <React.Fragment>
                            <em className={s.attachment}>
                                Loading attachment...
                            </em>
                            <LoadingState context="attachment" />
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <p className={s.attachment}>
                                {filename}
                            </p>
                            <div className={s.cta}>
                                <p className={s.text}>
                                    View
                                </p>
                                <Download
                                    color="#fff"
                                    size={30}
                                    className={s.svg}
                                />
                            </div>
                        </React.Fragment>
                    }
                </a>
                }
            </div>
        </IntersectionVisible>
    );
};

Attachment.propTypes = {
    id: number,
    url: string,
    error: object,
    filename: string,
    getAttachment: func,
    mimeType: string,
};

export default Attachment;